import dayjs from 'dayjs';
import 'dayjs/locale/pt-br';

dayjs.locale('pt-br');

export default {
  install(Vue) {
    Vue.prototype.$dayjs = dayjs;
  }
};
